import { render, staticRenderFns } from "./CreateNewRequest.vue?vue&type=template&id=22066920&"
import script from "./CreateNewRequest.vue?vue&type=script&lang=js&"
export * from "./CreateNewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports